// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Redux:
import { getOffersData } from 'actions/page'

class Offers extends React.Component {
	componentDidMount() {
		// Get data:
		this.props.dispatch( getOffersData() )
	}

	render() {
		const { offersById } = this.props
		let markup = ''

		if ( offersById && Object.keys( offersById ).length ) {
			markup = Object.keys( offersById )
				.map( key => {
					let item = offersById[ key ]

					return (
						<div className="offer" key={ item.id }>
							<div className="-image">
								<img
									alt={ item.image.alt }
									src={ item.image.url }
									srcSet={ item.image.srcset }
									sizes="50vw"
								/>
							</div>

							<div className="-title">
								<h2>{ item.title }</h2>
							</div>

							<div className="-content">
								<div className="-text" dangerouslySetInnerHTML={ { __html: item.content } }></div>
							</div>
						</div>
					)
				})
		}

		return (
			<div className="offers">
				{ markup }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		offersById: state.page.offersById
	}
}

export default connect( mapStateToProps )( Offers )
